import { LIB_UI_ACTIVITY_DETECTED, LIB_UI_CLEAR_LOCK_ERROR, LIB_UI_SET_LOCK } from 'lib/constants/libConstants';

export const uiActivityDetected = (data) => ({ type: LIB_UI_ACTIVITY_DETECTED, data });
export const uiSetLock = (data) => ({ type: LIB_UI_SET_LOCK, data });
export const clearLockError = () => ({ type: LIB_UI_CLEAR_LOCK_ERROR, data: undefined });
